import React from 'react';
import { buttonTheme } from 'utilities/theme';
import styled from 'styled-components';

const Button: React.FC<{
  uniqueId?: string;
  text: string;
  theme?: string | undefined;
  type: undefined | 'button' | 'submit' | 'reset';
  handleClick?: () => void;
  handleKeyDown?: (e: any) => void;
  disabled?: boolean;
}> = ({
  text,
  theme,
  type,
  handleClick,
  handleKeyDown,
  disabled,
  uniqueId
}) => {
  return (
    <Link
      id={uniqueId}
      disabled={disabled}
      type={type}
      onKeyDown={handleKeyDown}
      onClick={disabled ? undefined : handleClick}
      theme={theme}
    >
      {text}
    </Link>
  );
};

const Link = styled.button<{ theme: string }>`
  font-family: Roboto, 'Roboto Fallback' !important;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.01em !important;
  text-align: center;
  background-color: rgba(0, 50, 30, 1);
  height: 54px;
  padding: 0px;
  &:focus {
    outline: 2px dotted #000000;
  }
  &:hover {
    cursor: pointer;
  }
  ${(props) => (props ? buttonTheme : 'unset')};
`;

export default Button;
